import { createMuiTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#fff',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#1e88e5',
    },
    secondary: {
      main: '#0091ea',
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows,
  typography
});

export default theme;
